// Reveal.js — Aparição suave de uma seção quando ela entra na tela.
// Papel dos `AnimatedContent` / `FadeContent` do react-bits, com duas escolhas
// deliberadas: a animação é CSS (não JavaScript) e o estado final não depende
// de a animação rodar — ver o comentário de useRevelar.js.
//
// Regras que este componente carrega para não serem esquecidas caso a caso:
//  1. `useReducedMotion`: quem pediu menos animação recebe o conteúdo pronto.
//  2. Revela uma vez. Reanimar a cada scroll enjoa e atrapalha quem relê.
//  3. Deslocamento curto (16 px). Numa vitrine o movimento leva o olho até a
//     capa — não pode competir com ela.
import React, { useRef } from "react";
import { useReducedMotion } from "motion/react";
import useRevelar, { classesDoEstado } from "./useRevelar";

const DESLOCAMENTO = {
  up: { "--revelar-y": "16px" },
  down: { "--revelar-y": "-16px" },
  left: { "--revelar-x": "16px", "--revelar-y": "0px" },
  right: { "--revelar-x": "-16px", "--revelar-y": "0px" },
  none: { "--revelar-x": "0px", "--revelar-y": "0px" },
};

const Reveal = ({
  children,
  as: Tag = "div",
  direction = "up",
  delay = 0,
  duration = 0.5,
  amount = 0.15,   // fração do elemento visível para disparar
  className = "",
  style,
  ...rest
}) => {
  const ref = useRef(null);
  const estado = useRevelar(ref, amount);
  const reduzirMovimento = useReducedMotion();

  if (reduzirMovimento) {
    return <Tag className={className} style={style} {...rest}>{children}</Tag>;
  }

  return (
    <Tag
      ref={ref}
      className={`${classesDoEstado(estado)} ${className}`}
      style={{
        ...DESLOCAMENTO[direction],
        transitionDuration: `${duration}s`,
        transitionDelay: delay ? `${delay}s` : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
